{
  "version": 1,
  "asset_id": "e0c15e62-bbf4-4bf2-a41d-b91ef060af2b",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/e0c15e62-bbf4-4bf2-a41d-b91ef060af2b/cp504.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/e0c15e62-bbf4-4bf2-a41d-b91ef060af2b/cp504.jpg",
  "original_filename": "cp504.jpg",
  "size": 117384,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:29Z"
}
